import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
} from 'reactstrap';
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  confirmAction,
  openEditCareerModal,
  toggleModalLoading,
} from '../../actions/modalActions';
import { showError, showInfo } from '../../actions/notificationActions';

import ConfirmActionModal from '../ConfirmActionModal';
import InfoTab from './InfoTab';
import SupportMsgModal from '../SupportMsgModal';
import { callApi } from '../../utils';
import classnames from 'classnames';
import { connect } from 'react-redux';

class Detail extends Component {
  state = {
    career: null,
    meta: {},
    loading: true,
    loadingModal: false,
    supportMsgLoading: false,
    activeTab: '1',
    toggle: null,
    rows: [],
    page: 1,
    pages: 1,
    limit: 10,
  };

  componentDidMount() {
    this.loadCampaign();
  }

  startLoad = () => this.setState({ loading: true });
  stopLoad = () => this.setState({ loading: false });

  scrollToTop = () =>
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);

  loadCampaign = () => {
    this.startLoad();
    callApi(`/careers/${this.props.match.params.id}`)
      .then((res) => {
        this.setState({
          loading: false,
          career: res.data,
        });
      })
      .catch((err) => {
        this.stopLoad();
        this.props.dispatch(showError(err.message));
      });
  };

  editCampaign = () => {
    this.props.dispatch(openEditCareerModal(this.props.match.params.id));
  };

  deleteCampaign = () => {
    this.props.dispatch(
      confirmAction({
        title: 'Delete Job Listing!!',
        confirmText: 'Are you sure you want to delete this job listing?',
        confirmCallback: () => {
          this.toggleModalLoading();
          callApi(`/careers/${this.props.match.params.id}`, {}, 'delete')
            .then((res) => {
              this.toggleModalLoading();
              this.props.dispatch(
                showInfo('Job listing deleted successfully', 'Success')
              );
              this.props.history.push('/careers');
            })
            .catch((err) => {
              this.toggleModalLoading();
              this.props.dispatch(showError(err.message));
            });
        },
      })
    );
  };

  setPage = (page) => {
    if (page) {
      this.setState({ page }, () => {
        this.loadView();
      });
    }
  };

  toggleModalLoading = () => {
    this.props.dispatch(toggleModalLoading(this.state.loadingModal));
  };

  setInput = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  render() {
    let { career, loading } = this.state;

    const { history, match, location } = this.props;

    if (!career) return <React.Fragment />;

    return (
      <div className="content">
        <ConfirmActionModal />
        <SupportMsgModal customer_id={this.props.match.params.id} />
        <Row>
          <Col xs={12} md={12}>
            <Card>
              <CardHeader className="ml-2">
                <div className="d-flex justify-content-between align-contents-start">
                  <div>
                    <CardTitle>{career.title || 'Loading...'}</CardTitle>
                    <p className="category">Job Listing</p>
                  </div>
                  <div>
                    <Button
                      disabled={loading}
                      color={'success'}
                      onClick={this.editCampaign}
                    >
                      Edit
                    </Button>
                    <Button
                      disabled={loading}
                      color={'danger'}
                      onClick={this.deleteCampaign}
                    >
                      Delete
                    </Button>
                  </div>
                </div>
              </CardHeader>

              <CardBody>
                <div>
                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        style={{ color: 'black' }}
                        href="#"
                        className={classnames({
                          active: location.pathname === `${match.url}`,
                        })}
                        onClick={() => {
                          history.push(`${match.url}`);
                        }}
                      >
                        General
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <br />
                  {career && (
                    <Switch>
                      <Route exact path={`${match.path}`}>
                        <InfoTab career={career} />
                      </Route>
                    </Switch>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect()(Detail);
